import { create } from 'zustand'

type SortType = 'newest' | 'oldest' | 'price-asc' | 'price-desc'
type PriceRangeType = 'under-25' | '25-50' | '50-100' | '100'

type FilterType = {
  categories: string[]
  sizes: string[]
  priceRange?: PriceRangeType[]
  colors?: string[]
}

interface FilterState {
  filters: FilterType
  sort?: SortType | null
  setFilters: (
    type: 'category' | 'size' | 'price' | 'color',
    val: string
  ) => void
  setSort: (val: SortType | null) => void
  resetFilters: () => void
}

export const useFilterStore = create<FilterState>((set) => ({
  filters: {
    categories: [],
    sizes: [],
    priceRange: [],
  },
  sort: null,
  setFilters: (type, filter) => {
    set((state) => {
      const filterType =
        type === 'category'
          ? 'categories'
          : type === 'price'
          ? 'priceRange'
          : type === 'color'
          ? 'colors'
          : 'sizes'
      const currentFilters = state.filters[filterType] ?? []

      let filters: any = []

      if (filterType === 'priceRange') {
        filters = currentFilters.includes(filter)
          ? currentFilters.filter((f) => f !== filter)
          : [...currentFilters, filter]
      } else {
        filters = currentFilters.includes(filter)
          ? currentFilters.filter((f) => f !== filter)
          : [...currentFilters, filter]
      }

      return {
        filters: {
          ...state.filters,
          [filterType]: filters,
        },
      }
    })
  },
  setSort: (sort) => set({ sort }),
  resetFilters: () =>
    set({
      filters: {
        categories: [],
        sizes: [],
        priceRange: [],
      },
    }),
}))

export const SortTypes = [
  { label: 'Newest to Oldest', value: 'newest' },
  { label: 'Oldest to Newest', value: 'oldest' },
  { label: 'Price: Low to High', value: 'price-asc' },
  { label: 'Price: High to Low', value: 'price-desc' },
]

export const PriceRangeTypes = [
  { label: 'Under $25', slug: 'under-25', value: [0, 25] },
  { label: '$25 - $50', slug: '25-50', value: [25, 50] },
  { label: '$50 - $100', slug: '50-100', value: [50, 100] },
  { label: '$100+', slug: '100', value: [100, Infinity] },
]
